import { Info } from "@mui/icons-material";

import BaseField from "../ui/BaseField";
import UpdatedByAtTooltip from "../ui/UpdatedByAtTooltip/UpdatedByAtTooltip";
import ValueWithFallback from "../ui/ValueWithFallback";

const MedicalStatus = ({ fieldName, value, flag, clock, updatedAt, updatedBy }) => {
  const hasPreviousHistory = (updatedAt, updatedBy) => {
    if (updatedAt === null || updatedBy === null) {
      return false;
    }
    return true;
  };
  return (
    <BaseField
      id="SB-Medical-Status"
      testId="SB-Medical-Status"
      fieldName={fieldName}
      label={"Medical Status"}
      value={value}
      flag={flag}
      clock={clock}
    >
      {ValueWithFallback(value)}{" "}
      {hasPreviousHistory(updatedAt, updatedBy) && (
        <UpdatedByAtTooltip
          id={fieldName + " updated_tooltip"}
          title={"Last Modified at"}
          date={updatedAt}
          name={updatedBy}
        >
          <span className="cursor-default text-slate-700">
            <Info fontSize="inherit" />
          </span>
        </UpdatedByAtTooltip>
      )}
    </BaseField>
  );
};

export default MedicalStatus;
